// Hex-encode a SHA-256 digest of the given file's bytes.
// Returns 64 lowercase hex chars. Uses the Web Crypto API (available in all
// modern browsers and Node 18+) and reads the file body once via arrayBuffer().
export const sha256HexOfFile = async (file: File): Promise<string> => {
    const buffer = await file.arrayBuffer();
    const digest = await crypto.subtle.digest("SHA-256", buffer);
    const bytes = new Uint8Array(digest);
    let hex = "";
    for (const byte of bytes) {
        hex += byte.toString(16).padStart(2, "0");
    }
    return hex;
};
